export default{
	name : 'payment_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		zhxy() {
            // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.zhxy%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;45;1';
		},
		shjf() {
            // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.shjf%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;44;1';
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/payment_dialog/payment_dialog.controller.js